import * as React from "react";
const SvgFiRrCommentsDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comments-dollar_svg__a)">
      <path
        fill="#062147"
        d="M24 16v5a3 3 0 0 1-3 3h-5c-2.955 0-5.535-1.615-6.92-4.004a11 11 0 0 0 2.242-.248A5.99 5.99 0 0 0 16 22h5a1 1 0 0 0 1-1v-5a5.99 5.99 0 0 0-2.252-4.678c.156-.724.242-1.473.248-2.242C22.385 10.465 24 13.045 24 16M8.703 18H3c-1.493 0-3-1.134-3-3.666v-5.04C0 4.588 3.823.342 8.349.023a9.03 9.03 0 0 1 7.015 2.613 9.01 9.01 0 0 1 2.613 7.015C17.658 14.177 13.411 18 8.703 18m0-2q.107 0 .214-.004A1 1 0 0 1 8 15v-1h-.268a3.01 3.01 0 0 1-2.598-1.499A1 1 0 0 1 6.865 11.5c.178.308.511.5.867.5H10c.551 0 1-.449 1-1a.77.77 0 0 0-.644-.76l-3.042-.507A2.76 2.76 0 0 1 4.999 7c0-1.654 1.346-3 3-3V3a1 1 0 0 1 .976-.999q-.242 0-.486.017c-3.518.249-6.49 3.58-6.49 7.276v5.04c0 .391.072 1.666 1 1.666zm7.279-6.49a7.02 7.02 0 0 0-2.032-5.46 7 7 0 0 0-4.9-2.049A1 1 0 0 1 10 3v1h.268c1.067 0 2.063.575 2.598 1.5a1 1 0 0 1-1.731 1.001 1 1 0 0 0-.867-.5H8c-.551 0-1 .449-1 1 0 .378.271.698.644.76l3.042.507a2.76 2.76 0 0 1 2.315 2.733c0 1.654-1.346 3-3 3v1a1 1 0 0 1-.817.983c3.501-.243 6.561-3.108 6.799-6.473z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comments-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentsDollar;
